import axios from '@/api/axios'

const getKindsSport = () => {
  return axios.get(`/kindsSport`)
}

const addKindsSport = (sport) => {
  return axios.post('/kindsSport', sport)
}

const getKindsSportType = () => {
  return axios.get(`/kindsSportType`)
}

const getKindsSportItem = (id) => {
  return axios.get(`/kindsSport/${id}`)
}

const editKindsSport = (sport) => {
  return axios.put(`/kindsSport/${sport.id}`, sport)
}

const deleteKindsSport = (id) => {
  return axios.delete(`/kindsSport/${id}`)
}

export default {
  getKindsSport,
  addKindsSport,
  deleteKindsSport,
  getKindsSportType,
  getKindsSportItem,
  editKindsSport,
}
